export const getCampaignActionButtons = ({
  campaign,
  handleEditCampaign,
  handleSummaryClick,
  handleCopyClick,
  handleDeleteClick,
  handleRewardCampaign,
  hasAccess,
  isBonusFlowEnabled,
}) => {
  const actionButtons = [
    {
      icon: "visibility",
      onClick: () => {
        handleSummaryClick(campaign);
      },
    },
  ];

  const editableStatuses = ["draft", "published", "active", "inactive"];
  const deletableStatuses = ["draft", "published"];

  if (!(campaign?.type === "gift_processing" && isBonusFlowEnabled)) {
    hasAccess &&
      actionButtons.push({
        icon: "content_copy",
        onClick: () => handleCopyClick(campaign),
      });
    editableStatuses.includes(campaign?.campaignStatus?.toLowerCase()) &&
      hasAccess &&
      actionButtons.push({
        icon: "edit",
        onClick: () => handleEditCampaign(campaign),
      });

    deletableStatuses.includes(campaign?.campaignStatus?.toLowerCase()) &&
      hasAccess &&
      actionButtons.push({
        icon: "delete",
        onClick: () => handleDeleteClick(campaign.id),
      });
  }

  if (campaign?.type === "standard_campaign") {
    actionButtons.push({
      icon: "redeem",
      onClick: () => handleRewardCampaign(campaign),
    });
  }
  return actionButtons;
};
